/** @format */
import { TransactionSummary } from '@toucan/client/global/transaction';

export const transformExpiredQuotes = (
    transaction: TransactionSummary
): TransactionSummary => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Legacy code: do not use as an example.
    const tx = JSON.parse(JSON.stringify(transaction));

    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- Legacy code: do not use as an example.
    if (tx.quote) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- Legacy code: do not use as an example.
        tx.quote.expired = true;
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return -- Legacy code: do not use as an example.
    return tx;
};
